var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaoptimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.758,
    height: 22.206,
    viewBox: "0 0 24.758 22.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.999 -10.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.33,12.227H19.02V10.978a.428.428,0,0,0-.428-.428H13.034a.428.428,0,0,0-.425.428v1.249H6.419A.428.428,0,0,0,6,12.646v1.938a.428.428,0,0,0,.428.428h6.19v1.249a.428.428,0,0,0,.416.436h5.559a.428.428,0,0,0,.428-.428V15.021H30.33a.428.428,0,0,0,.428-.428V12.646a.428.428,0,0,0-.428-.419ZM6.844,14.165V13.082h5.773v1.083Zm11.313,1.688H13.47V11.405h4.7v4.44Zm11.757-1.688H19.02V13.082H29.914Z",
    transform: "translate(0)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.33,40.746H26.7V39.5a.425.425,0,0,0-.428-.425H20.725a.425.425,0,0,0-.425.425v1.241H6.427A.428.428,0,0,0,6,41.184V43.12a.428.428,0,0,0,.428.439H20.3v1.252a.425.425,0,0,0,.425.425h5.551a.425.425,0,0,0,.428-.425V43.559H30.33a.428.428,0,0,0,.428-.439V41.184a.428.428,0,0,0-.428-.439ZM6.844,42.7V41.609H20.292V42.7Zm19,1.688H21.153V39.932h4.7v4.44ZM29.9,42.7H26.7V41.609h3.21Z",
    transform: "translate(0 -20.503)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.33,69.277h-14.3V68.028A.428.428,0,0,0,15.6,67.6H10.054a.428.428,0,0,0-.425.428v1.249h-3.2A.428.428,0,0,0,6,69.7v1.947a.428.428,0,0,0,.428.428h3.2v1.249a.428.428,0,0,0,.425.428H15.6a.428.428,0,0,0,.428-.428V72.071h14.3a.428.428,0,0,0,.428-.419V69.7a.428.428,0,0,0-.428-.428ZM6.844,71.215V70.132H9.629v1.083ZM15.169,72.9H10.482V68.452h4.7v4.44ZM29.9,71.215H16.033V70.132H29.914Z",
    transform: "translate(0 -40.999)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaoptimize);
export default __webpack_public_path__ + "static/media/mediaoptimize.b883baf1.svg";
export { ForwardRef as ReactComponent };